import { CaseCalculationAlternativePart } from '../interfaces/Case';

export const mapAlternativePartToCalculationPart = (
  alternativePart: CaseCalculationAlternativePart,
  groupedUniqueId: string | null,
  excludeFromOrder: boolean | null
) => ({
  alternativePrice: alternativePart.alternativePrice,
  alternativePartDiscount: alternativePart.alternativePartDiscount,
  alternativeGuideNumber: alternativePart.alternativeGuideNumber,
  alternativePartCode: alternativePart.alternativePartCode,
  alternativePartQuality: alternativePart.alternativePartQuality,
  alternativePartQualityId: alternativePart.alternativePartQualityId,
  alternativePartName: alternativePart.name,
  alternativePartStockLocation: alternativePart.stockLocation,
  alternativePartStockQuantity: alternativePart.availableQuantity,
  supplier: alternativePart.supplier,
  supplierId: alternativePart.supplierId,
  producer: alternativePart.producer,
  deliveryTime: alternativePart.deliveryTime || null,
  validityTime: alternativePart.validityTime || null,
  codeType: alternativePart.codeType || null,
  type: alternativePart.type || null,
  orderCode: alternativePart.orderCode || null,
  locationId: alternativePart.locationId || null,
  alternativePartRemarks: alternativePart.remarks,
  minQty: alternativePart.minQty,
  packing: alternativePart.packing,
  bundleItem: alternativePart.bundleItem,
  bundleNo: alternativePart.bundleNo,
  bundleQuantity: alternativePart.bundleQuantity,
  excludeFromOrder: excludeFromOrder,
  isChild: alternativePart.isChild,
  productId: alternativePart.productId || null,
  codEan: alternativePart.codEan || null,
  groupedUniqueId: groupedUniqueId,
  alternativeNetPrice: alternativePart.alternativeNetPrice,
  alternativePriceWithoutDiscount: alternativePart.alternativePriceWithoutDiscount,
  availableQuantity: alternativePart.availableQuantity,
  isInStock: alternativePart.isInStock,
  isOwnStock: alternativePart.isOwnStock,
  partStockId: alternativePart.partStockId || null,
  expectedDeliveryDate: alternativePart.expectedDeliveryDate || null
});
